import React from 'react';
import { Card, Row, Col } from 'antd';

const LegendItem = ({ color, text }) => (
  <div style={{ display: 'flex', alignItems: 'center', margin: '0 12px' }}>
    <div 
      style={{ 
        width: 16, 
        height: 16, 
        borderRadius: '50%', 
        backgroundColor: color, 
        marginRight: 8 
      }} 
    />
    <span>{text}</span>
  </div>
);

const MapLegend = ({ useProximityFilter, proximityRange, showCompetitors, showPartners }) => {
  return (
    <Card 
      size="small" 
      style={{ marginTop: 8 }} 
      styles={{ body: { padding: '8px 12px' } }}
      title="Legenda"
    >
      <Row justify="center" align="middle" style={{ flexWrap: 'wrap' }}>
        <Col>
          <LegendItem color="grey" text="Bozza" />
        </Col>
        <Col>
          <LegendItem color="blue" text="Inviato" />
        </Col>
        <Col>
          <LegendItem color="orange" text="Accettato" />
        </Col>
        <Col>
          <LegendItem color="green" text="Pagato" />
        </Col>
        <Col>
          <LegendItem color="red" text="Rifiutato" />
        </Col>
        
        {showCompetitors && (
          <Col>
            <div style={{ display: 'flex', alignItems: 'center', margin: '0 12px' }}>
              <div 
                style={{ 
                  width: 16, 
                  height: 16, 
                  borderRadius: '50%', 
                  backgroundColor: '#000000', 
                  marginRight: 8 
                }} 
              />
              <span>Competitor</span>
            </div>
          </Col>
        )}
        
        {showPartners && (
          <Col>
            <div style={{ display: 'flex', alignItems: 'center', margin: '0 12px' }}>
              <div 
                style={{ 
                  width: 16, 
                  height: 16, 
                  borderRadius: '50%', 
                  background: 'linear-gradient(to right, red, orange, yellow, green, blue, indigo, violet)', 
                  marginRight: 8 
                }} 
              />
              <span>Partner</span>
            </div>
          </Col>
        )}
        
        {useProximityFilter && (
          <Col>
            <div style={{ display: 'flex', alignItems: 'center', margin: '0 12px' }}>
              <div 
                style={{ 
                  width: 16, 
                  height: 16, 
                  borderRadius: '50%', 
                  backgroundColor: 'rgba(255, 0, 0, 0.3)', 
                  border: '2px solid rgba(255, 0, 0, 0.5)',
                  marginRight: 8 
                }} 
              />
              <span>Area di ricerca ({proximityRange} km)</span>
            </div>
          </Col>
        )}
      </Row>
    </Card>
  );
};

export default MapLegend;